import HistoryItems from './component';
import { HistoryItemsProps } from './types';

export default HistoryItems;
export type { HistoryItemsProps };
